import React, { useEffect, useState } from "react";
import classes from "./menu.module.scss";
import { FaBars, FaSignOutAlt, FaSpinner } from "react-icons/fa";
import { UseHttpAssistant, UseUserAssistant } from "@codes-on-us/assistant";
import { useLayoutEffectLevel2 } from "../../utilities/customHooks/customHooks";
import { User } from "../../models/User";

const Menu: React.FC = () => {
  const { Get, Post } = UseHttpAssistant();
  const [user, setUser] = useState<User>();
  const [mobileNavVisible, setMobileNavVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  const getActiveClass = (path: string) => {
    return window.location.pathname === path ? classes.active : "";
  };

  const Logout = async () => {
    await Post("/Auth/Logout", undefined, true);
    window.location.reload();
  };
  const checkUser = async () => {
    try {
      var currentUser = (await Get("/Auth/Ping"))?.value as User;
      if (currentUser) setUser(currentUser);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkUser();
  }, []);

  return (
    <div
      className={`${classes.module} ${mobileNavVisible && classes.moduleMobileNavVisible}`}
    >
      <div
        className={`${classes.logo} ${mobileNavVisible && classes.logoMobileNavVisible}`}
      >
        <img
          onClick={() => (window.location.href = "/")}
          src="/images/logo-dark.png"
          alt="Logo"
        />
        <div onClick={() => setMobileNavVisible(!mobileNavVisible)}>
          <FaBars size={25} />
        </div>
      </div>
      <nav
        className={`${classes.nav} ${mobileNavVisible && classes.navMobileNavVisible}`}
      >
        <ul className={classes.navList}>
          <li
            className={getActiveClass("/")}
            onClick={() => (window.location.href = "/")}
          >
            Home
          </li>
          <li
            className={getActiveClass("/solutions")}
            onClick={() => (window.location.href = "/solutions")}
          >
            Solutions & Services
          </li>
          <li
            className={getActiveClass("/pricing")}
            onClick={() => (window.location.href = "/pricing")}
          >
            Pricing
          </li>
          <li
            className={getActiveClass("/aboutus")}
            onClick={() => (window.location.href = "/aboutus")}
          >
            About Us
          </li>
          <li
            className={getActiveClass("/contactus")}
            onClick={() => (window.location.href = "/contactus")}
          >
            Contact Us
          </li>
        </ul>
      </nav>
      {!loading ? (
        !user ? (
          <div
            className={`${classes.signout} ${classes.buttons} ${mobileNavVisible && classes.signOutMobileNavVisible}`}
          >
            <button
              className={classes.primary}
              onClick={() => {
                setLoading(true);
                window.location.href = process.env
                  .REACT_APP_PANEL_ADDRESS as string;
              }}
            >
              TX-Genius&nbsp;Panel
            </button>
          </div>
        ) : (
          <div
            className={`${classes.signout} ${classes.buttons} ${mobileNavVisible && classes.signOutMobileNavVisible}`}
          >
            <button
              className={classes.primary}
              onClick={() => {
                setLoading(true);
                Logout();
              }}
            >
              <span className={classes.detail}>Sign Out</span>
              <FaSignOutAlt />
            </button>
          </div>
        )
      ) : (
        <div
          className={`${classes.signout} ${classes.buttons} ${mobileNavVisible && classes.signOutMobileNavVisible}`}
        >
          <button className={classes.primary} onClick={() => {}}>
            <FaSpinner />
          </button>
        </div>
      )}
    </div>
  );
};

export default Menu;
